module.exports = __webpack_public_path__ + "img/header-memoireRingsCheap.2bf6308.webp";